export const getAccessToken = () => localStorage.getItem('token')?.slice(1, -1);

export const setTokens = <T>(authRes: T) => {
  localStorage.setItem('token', JSON.stringify(authRes));
};
export const isAuthenticated = () => (getAccessToken() ? true : false);
